<div class="row m-0">
  <ul class="nav menu">
    <li class="{{GrpActiveTab}}"><a class="tab-a" [routerLink]="['/supplier-group']" >Group</a></li>
    <li class="{{cmpActiveTab}}"><a class="tab-a" [routerLink]="['/company']">Company</a></li>
    <li
      *ngIf="roleVariableHide==true || superUserShow==true || showForConsult==false || showForSupplier==false"
      class="{{SitActiveTab}}"
    ><a class="tab-a" [routerLink]="['/sites']">Site</a></li>
    <li
      *ngIf="superUserShow==true || roleVariableHide==true || showForConsult==false "
      class="{{ConActiveTab}}"
    ><a class="tab-a" [routerLink]="['/contacts']">Contacts</a></li>
    <li
      *ngIf="roleVariableHide2==true ||superUserShow==true || roleIsManager==true || showBuyerProfile==false"
      class="{{WkfActiveTab}}"
    ><a class="tab-a" [routerLink]="['/workflow']">Workflow</a></li>
    <li *ngIf="roleVariableHide2==true" class="{{OrbisActiveTab}}"><a class="tab-a" [routerLink]="['/orbis']">Orbis</a></li>
    <li *ngIf="superUserShow==true" class="{{AdminActiveTab}}"><a class="tab-a" [routerLink]="['/administration']">Administration</a></li>
  </ul>
</div>